
import './App.css';
import { HashRouter, Route} from 'react-router-dom'
import Header from './Header'
import Common from './Common'
import Synopsis from './Synopsis'
import Chacter from './Characters'
import Trailer from './Trailer'
import Main from './Main'

function App() {
  return (
    <div id='wrap'>
        <HashRouter>
          <Route path="/" component={Header}></Route>
          <Route path="/" exact={true} component={Main}></Route>
          <Route path="/" component={Common}></Route>
          <Route path="/trailer" component={Trailer}></Route>
          <Route path="/character" component={Chacter}></Route>
          <Route path="/synopsis" component={Synopsis}></Route>
        </HashRouter>
    </div>
  );
}

export default App;
